import { useParams } from "react-router-dom";

import InternalNotes from "../../../../../components/modules/providers/provider-management/components/management/InternalNotes";
import Navigation from "../../../../../components/navigations/provider-management/detail/management/navigation";

export default function Template() {
  const { id } = useParams();

  return (
    <Navigation activeTab="internal-notes" providerId={id}>
      <InternalNotes />
    </Navigation>
  );
}
